var src,srcset,wnw_windowWidth,wnw_windowHeight,critical2,cls_css,lazyBackground,lazyIframe,lazyPoster,lazyLoadVideo,lazybg,lazybg2,s,i,flag=1,external_single_loaded=1;

document.addEventListener("DOMContentLoaded", function() {
	wnw_windowWidth=window.innerWidth || screen.width;
	wnw_windowHeight=window.innerHeight || screen.height;
	lazyLoadImg2();
	lazyLoadBackground2();
	//window.addEventListener("scroll", function() {
	//	wnw_init();
	//});
	//window.addEventListener("mousemove", function() {
	//	wnw_init();
	//});
	//window.addEventListener("touchstart", function() {
	//	wnw_init();
	//});
    wnw_init();
});

function wnw_init() {
	cls_css = document.querySelectorAll(".cls_css");
	cls_css.forEach(function(a) {
		a.remove();
	});
	lazyLoadCss();
	lazyLoadStyle();
	lazyLoadImg();
	lazyLoadBackground();
	lazyLoadVideo();
	lazyLoadIframe();
	lazyLoadPoster();
	if (flag) {
		flag = 0;
		load_all_js();
	}
}

function insertAfter(newNode, referenceNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function lazyLoadImg() {
	var imgs = document.querySelectorAll("img.lazy2");

	for (i = 0; i < imgs.length; i++) {
			if (wnw_windowWidth < 600) {
				src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
			} else {
				src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
			}
			srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				imgs[i].src = src;
			}
			if (srcset != null && srcset != "") {
				imgs[i].srcset = srcset;
			}
			imgs[i].classList.remove("lazy2");
	}
}

var wnwImageObserver = null;
var wnwObservedImages = new Set();

function wnwLoadVisibleImage(img) {
	var width = window.innerWidth || wnw_windowWidth || screen.width;
	var imageSource = width < 600
		? (img.dataset.mobsrc === undefined ? img.dataset.src : img.dataset.mobsrc)
		: (img.dataset.src === undefined ? img.src : img.dataset.src);
	var imageSrcset = img.getAttribute('data-srcset') || '';
	if (imageSource != null && imageSource !== '') img.src = imageSource;
	if (imageSrcset !== '') img.srcset = imageSrcset;
	img.classList.remove('lazy3');
}

function lazyLoadImg2() {
	var imgs = document.querySelectorAll("img.lazy3");
	if ('IntersectionObserver' in window) {
		if (!wnwImageObserver) {
			wnwImageObserver = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					if (!entry.isIntersecting) return;
					var img = entry.target;
					wnwImageObserver.unobserve(img);
					wnwObservedImages.delete(img);
					if (img.classList.contains('lazy3')) wnwLoadVisibleImage(img);
				});
			});
		}
		wnwObservedImages.forEach(function(img) {
			if (!img.isConnected || !img.classList.contains('lazy3')) {
				wnwImageObserver.unobserve(img);
				wnwObservedImages.delete(img);
			}
		});
		imgs.forEach(function(img) {
			if (wnwObservedImages.has(img)) return;
			wnwObservedImages.add(img);
			wnwImageObserver.observe(img);
		});
		return;
	}

	/* (P1 perf, Jul 2026) Read phase first: writing src/classList in the same loop as
	   getBoundingClientRect() invalidated layout between iterations, forcing a reflow
	   per image (PSI "forced reflow" attributed to this file). All rects are captured
	   before any write; the visibility test and writes are unchanged. */
	var wnwRects = [];
	for (i = 0; i < imgs.length; i++) {
		wnwRects[i] = imgs[i].getBoundingClientRect();
	}
	for (i = 0; i < imgs.length; i++) {
		var elemRect = wnwRects[i];
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 0) {
			if (wnw_windowWidth < 600) {
				src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
			} else {
				src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
			}
			srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				imgs[i].src = src;
			}
			if (srcset != null && srcset != "") {
				imgs[i].srcset = srcset;
			}
			imgs[i].classList.remove("lazy3");
		}
	}
}

function lazyLoadBackground() {
	lazyBackground = document.querySelectorAll(".lazybg");
	lazyBackground.forEach(function(a) {
		if (wnw_windowWidth < 600) {
			lazybg = (a.dataset.mobstyle === undefined) ? a.dataset.style : a.dataset.mobstyle;
		} else {
			lazybg = (a.dataset.style === undefined) ? a.style : a.dataset.style;
		}
		if (lazybg != null && lazybg != "") {
			a.style = lazybg;
		}
		a.classList.remove("lazybg");
	});
}

function lazyLoadBackground2() {
	lazyBackground = document.querySelectorAll(".lazybg2");
	/* (P1 perf, Jul 2026) Same read-then-write split as lazyLoadImg2 above. */
	var wnwBgRects = [];
	lazyBackground.forEach(function(a, idx) {
		wnwBgRects[idx] = a.getBoundingClientRect();
	});
	lazyBackground.forEach(function(a, idx) {
		var elemRect = wnwBgRects[idx];
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 0) {
            if (wnw_windowWidth < 600) {
                lazybg = (a.dataset.mobstyle === undefined) ? a.dataset.style : a.dataset.mobstyle;
            } else {
                lazybg = (a.dataset.style === undefined) ? a.style : a.dataset.style;
            }
            if (lazybg != null && lazybg != "") {
                a.style = lazybg;
            }
            a.classList.remove("lazybg2");
		}
	});
}

function lazyLoadCss() {
	var lazyLink = document.querySelectorAll("link[data-href]");
	for (i = 0; i < lazyLink.length; i++) {
		var css_element = document.createElement("link");
		css_element.href = lazyLink[i].getAttribute("data-href");
		css_element.rel = "stylesheet";
		lazyLink[i].parentNode.insertBefore(css_element, lazyLink[i]);
		delete lazyLink[i].dataset.href;
		lazyLink[i].parentNode.removeChild(lazyLink[i]);
	}
}

function lazyLoadStyle() {
	var lazyStyle = document.querySelectorAll("style[type=lazyload2]");
	for (i = 0; i < lazyStyle.length; i++) {
		var style_element = document.createElement("style");
		style_element.innerHTML = lazyStyle[i].innerHTML;
		lazyStyle[i].parentNode.insertBefore(style_element, lazyStyle[i]);
		lazyStyle[i].parentNode.removeChild(lazyStyle[i]);
	}
}

function lazyLoadVideo() {
	lazyVideo = document.querySelectorAll("video");
	lazyVideo.forEach(function(a) {
		if (a.dataset.src != null && a.dataset.src != "") {
			a.src = a.dataset.src;
			a.load();
			a.muted = true;
			a.play();
			delete a.dataset.src;
		}
	});
}

function lazyLoadIframe() {
	lazyIframe = document.querySelectorAll("iframe");
	lazyIframe.forEach(function(a) {
		if (a.dataset.src != null && a.dataset.src != "") {
			a.src = a.dataset.src;
			delete a.dataset.src;
		}
	});
}

		
function lazyLoadPoster() {	
	var lazyPoster = document.querySelectorAll("video[data-poster]");	
	lazyPoster.forEach(function(a) {	
		if (a.dataset.poster != null && a.dataset.poster != "") {	
			a.poster = a.dataset.poster;	
			delete a.dataset.poster;	
		}	
	});	
}

function w3_load_js_uri(static_script) {
	var ext_js_element = document.createElement("script");
	if (typeof(static_script.attributes) != "undefined") {
		for (var att, i3 = 0, atts = static_script.attributes, n3 = atts.length; i3 < n3; i3++) {
			att = atts[i3];
			if (att.nodeName == "data-type" ) {
				ext_js_element.setAttribute("type", att.nodeValue);
			}
			if (att.nodeName != "data-src" && att.nodeName != "type") {
				ext_js_element.setAttribute(att.nodeName, att.nodeValue);
			}
		}
	}
	ext_js_element.src = static_script.getAttribute("data-src");
	insertAfter(ext_js_element, static_script);
	delete static_script.dataset.src;
	delete static_script.type;
	static_script.parentNode.removeChild(static_script);
	return ext_js_element;
}

function w3_load_inline_js_single(script) {
	if (!external_single_loaded) {
		setTimeout(function() {
			w3_load_inline_js_single(script);
		}, 100);
		return false;
	}
	s = document.createElement("script");
	for (var i2 = 0; i2 < script.attributes.length; i2++) {
		var attrib = script.attributes[i2];
		if (attrib.name == "data-type") {
			s.setAttribute("type", attrib.value);
		}
		if (attrib.name != "type") {
			s.setAttribute(attrib.name, attrib.value);
		}
	}
	s.innerHTML = script.innerHTML;
	insertAfter(s, script);
	script.parentNode.removeChild(script);
}

function lazyLoadScripts() {
	var static_script = document.querySelectorAll("script[type=lazyload2]");
	if (static_script.length < 1) {
      	document.body.classList.add("wnw_loaded");
		fullJSLoadedCB();
		return;
	}
	if (static_script[0].getAttribute("data-src") !== null) {
		var js_obj = w3_load_js_uri(static_script[0]);
		js_obj.onload = function() {
			lazyLoadScripts();
		};
		js_obj.onerror = function() {
			lazyLoadScripts();
		};
	} else {
		w3_load_inline_js_single(static_script[0]);
		lazyLoadScripts();
	}
}

function wnwAnalytics() {
	var script2 = document.querySelectorAll(".analytics");
	script2.forEach(function(analyticsScript) {
		trekkie.integrations=false;
		s = document.createElement("script");
		s.innerHTML = analyticsScript.innerHTML;
		insertAfter(s, analyticsScript);
		analyticsScript.parentNode.removeChild(analyticsScript);
	});
}

function wnwBoomerang() {
	var script2 = document.querySelectorAll(".boomerang");
	script2.forEach(function(boomerangScript) {
		window.BOOMR.version=false;
		s = document.createElement("script");
		s.innerHTML = boomerangScript.innerHTML;
		insertAfter(s, boomerangScript);
		boomerangScript.parentNode.removeChild(boomerangScript);
	});
}

function load_all_js() {
	if(Shopify.designMode || window.location.href.indexOf("/cart") > -1 || window.location.href.indexOf("/checkout") > -1) {
		console.log("No-optimization");
	} else {
		console.log("Yes-optimization");
		setTimeout(function() {
			wnwAnalytics();		
			wnwBoomerang();
	  	},100);
		setTimeout(function() {
			var wnw_load_event = document.createEvent("Event");
			wnw_load_event.initEvent("wnw_load", true, true);
			window.document.dispatchEvent(wnw_load_event);
		}, 500);
		setTimeout(function() {
			var DOMContentLoaded2_event = document.createEvent("Event");
			DOMContentLoaded2_event.initEvent("DOMContentLoaded2", true, true);
			window.document.dispatchEvent(DOMContentLoaded2_event);
		}, 5000);

	}

	lazyLoadScripts();
	// CLS FIX (Jul 2026): the 9999ms timer-removal of .critical2 yanked the CLS
	// scaffold rules (contain/min-height on collection description, store-highlights
	// etc.) mid-session and caused a 1.0 layout shift on mobile collection pages
	// (GSC: 126 URLs @ Group CLS 1.00; confirmed live: STYLE.critical2 REMOVED at
	// 13.5s -> SHIFT 1.000 53ms later). Shifts within 500ms of discrete input are
	// excluded from CLS, so remove the scaffold on first click/keydown instead (or
	// when the tab is hidden - shifts aren't painted then). If the user never
	// interacts, the scaffold simply stays; it matches the settled layout.
	(function() {
		var done = false;
		function removeCritical2() {
			if (done) return;
			done = true;
			document.querySelectorAll(".critical2").forEach(function(a) { a.remove(); });
			document.removeEventListener("click", removeCritical2, true);
			document.removeEventListener("keydown", removeCritical2, true);
			document.removeEventListener("visibilitychange", onHidden, true);
		}
		function onHidden() { if (document.visibilityState === "hidden") removeCritical2(); }
		document.addEventListener("click", removeCritical2, true);
		document.addEventListener("keydown", removeCritical2, true);
		document.addEventListener("visibilitychange", onHidden, true);
	})();
	// .critical3 REMOVED-SWEEP DELETED (Jul 2026 audit).
	// The block it swept lived in layout/theme.liquid and is now emitted as
	// class="permanent-critical".  22 of its 38 declarations had no backing
	// anywhere in the permanent cascade, so deleting it at 3000ms changed
	// computed style on every page view.  Unlike the .critical2 sweep above,
	// no interaction was involved, so CLS counted every shift it caused in
	// full.  Nothing replaces this timer: the styles are meant to stay.
	// NOTE: The original implementation used setInterval with no delay.
	// Browsers clamp this, but it can still create continuous main-thread churn
	// and degrade INP/scroll performance (especially on desktop).
	// Replace with an event-driven + throttled scheduler.
	(function(){
		var scheduled = false;
		function updateViewport(){
			try {
				wnw_windowWidth = window.innerWidth || (screen && screen.width) || wnw_windowWidth;
				wnw_windowHeight = window.innerHeight || (screen && screen.height) || wnw_windowHeight;
			} catch(e) {}
		}
		function tick(){
			scheduled = false;
			updateViewport();
			try { lazyLoadImg2(); } catch(e) {}
			try { lazyLoadBackground2(); } catch(e) {}
			try { lazyLoadImg(); } catch(e) {}
			try { lazyLoadIframe(); } catch(e) {}
			try { lazyLoadPoster(); } catch(e) {}
			try { lazyLoadBackground(); } catch(e) {}
		}
		function schedule(){
			if (scheduled) return;
			scheduled = true;
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(tick);
			} else {
				setTimeout(tick, 16);
			}
		}

		function scheduleViewport() {
			// IntersectionObserver tracks registered images as the viewport moves.
			// New/changed media is enrolled by the mutation observer below. Only
			// legacy browsers and position-tested backgrounds need viewport scans.
			updateViewport();
			if ('IntersectionObserver' in window && 'MutationObserver' in window
				&& !document.querySelector('.lazybg2')) return;
			schedule();
		}

		// Run on user navigation/viewport changes.
		try {
			window.addEventListener('scroll', scheduleViewport, { passive: true });
			window.addEventListener('resize', scheduleViewport, { passive: true });
			window.addEventListener('orientationchange', scheduleViewport, { passive: true });
		} catch(e) {}

		var lazyMediaSelector = 'img.lazy2, img.lazy3, .lazybg, .lazybg2, iframe[data-src], video[data-poster]';
		function hasLazyMedia(node) {
			return node && node.nodeType === 1 && (node.matches(lazyMediaSelector) || node.querySelector(lazyMediaSelector));
		}
		if ('MutationObserver' in window && document.documentElement) {
			var mediaObserver = new MutationObserver(function(records) {
				var changed = records.some(function(record) {
					if (record.type === 'attributes') return hasLazyMedia(record.target);
					return Array.prototype.some.call(record.addedNodes || [], hasLazyMedia)
						|| Array.prototype.some.call(record.removedNodes || [], hasLazyMedia);
				});
				if (changed) schedule();
			});
			mediaObserver.observe(document.documentElement, {
				childList: true, subtree: true, attributes: true,
				attributeFilter: ['class', 'style', 'data-src', 'data-srcset', 'data-mobsrc', 'data-poster']
			});
		}
		document.addEventListener('toggle', schedule, true);
		document.addEventListener('visibilitychange', function() {
			if (!document.hidden) schedule();
		});

		// Initial follow-up tick (in case new nodes are injected shortly after init)
		setTimeout(schedule, 500);
	})();

}

function fullJSLoadedCB() {
	setTimeout(function() {
	});
}
